import type { SupportLogEntry } from '@peritasai/support-logging';
import { authenticatedFetch, resolvePeriverseApiBaseUrl } from '../shared';

const getSupportLogEndpoint = () => `${resolvePeriverseApiBaseUrl()}/logging/batch`;

export function postSupportLogs(logs: SupportLogEntry[]): Promise<Response> {
  return authenticatedFetch(getSupportLogEndpoint(), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ logs }),
  });
}

export function postSupportLogsBeacon(logs: SupportLogEntry[]): void {
  const body = JSON.stringify({ logs });
  void authenticatedFetch(getSupportLogEndpoint(), {
    method: 'POST',
    keepalive: true,
    headers: { 'Content-Type': 'application/json' },
    body,
  });
}
